import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "i18n";

import {
  setClientsListPaginationPage,
  setBudgetYear,
  setImportClientsBudgetModal
} from "actions";
import {
  fetchClientsList,
  fetchClientSuggestions,
  saveClientEntitySetting,
  getUpdatedBudget
} from "Thunks";

import { ICONS, SettingIcon, SvgIcon } from "../Common/Icons";
import TTPPaginator from "../Common/TTPPaginator";
import PageHeader from "../Common/PageHeader/PageHeader";

import ClientsList from "./ClientsList";
import ClientListFilter from "./ClientListFilter";

import styles from "./ClientsVue.local.scss";
import TTPModal, { DragModal } from "../Common/Modal/TTPModal";
import ModalCloseButton from "../Common/Modal/ModalCloseButton";
import classnames from "classnames";
import { Button, Switch } from "antd";
import debounce from "lodash.debounce";
import AsyncSelect from "react-select/lib/Async";
import { onSuccess, onError } from "Utils";
import ImportClientsBudgetModal from "./ImportClientsBudgetModal";
import { inIframe } from "Utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";
import { Progress } from "antd";
import { updatedBudgetByRole } from "../../actions/thunks";
import { error } from "autoprefixer/lib/utils";

class ClientVue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      yearDivIsVisible: false,
      filterFormIsVisible: false,
      selectedClient: null,
      clientEntityModalIsVisible: true,
      isProgressBar: true,
      updatedBudget: false,
      nbrUpdated: 1,
      nbrFetchingSideBar: 0,
      steps: 3,
      error: false,
      countNbrClickedButton: 0
    };
    this.loadClientSuggestions = debounce(this.loadClientSuggestions, 1000);
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearsSelect.bind(this)
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { paginationPage, pageSize, filter } = prevProps;
    if (
      filter !== this.props.filter ||
      paginationPage !== this.props.paginationPage ||
      pageSize !== this.props.pageSize
    ) {
      this.props.dispatch(fetchClientsList());
    }
  }

  handleOpenClientEntitySetting = client => {
    this.setState({
      clientEntityModalIsVisible: true,
      selectedClient: {
        ...client,
        isEntityClient: client.isEntityClient,
        disabledSave: !client.entityClient
      }
    });
  };

  handleCloseClientEntitySetting = () => {
    this.setState({ clientEntityModalIsVisible: false, selectedClient: null });
  };

  handleCheckIsClientEntity = () => {
    const { selectedClient } = this.state;
    this.setState({
      selectedClient: {
        ...selectedClient,
        isEntityClient: !selectedClient.isEntityClient,
        disabledSave: selectedClient.isEntityClient,
        entityClient: !selectedClient.isEntityClient
          ? null
          : selectedClient.entityClient
      }
    });
  };

  handleSaveClientEntitySetting = () => {
    const { year } = this.props;
    const { selectedClient } = this.state;
    this.props
      .dispatch(
        saveClientEntitySetting(
          selectedClient.id,
          year,
          selectedClient.isEntityClient,
          selectedClient.entityClient ? selectedClient.entityClient.id : null
        )
      )
      .then(
        res => {
          onSuccess(res, {
            title: _("saveSuccess"),
            body: _("successfulAction")
          });
          this.props
            .dispatch(fetchClientsList())
            .then(res => this.handleCloseClientEntitySetting());
        },
        err => {
          onError(_("errorOccured"));
        }
      );
  };

  handleSelectClientEntity = selected => {
    this.setState({
      selectedClient: {
        ...this.state.selectedClient,
        entityClient: { id: selected.value, name: selected.label },
        disabledSave: false
      }
    });
  };

  loadClientSuggestions = (searchWord, callback) => {
    const { year } = this.props;
    this.props
      .dispatch(fetchClientSuggestions(searchWord, "isEntity", year))
      .then(res => {
        let clientsList = res.value.data.data.filter(item => item !== null);
        const clients = clientsList.map(t => {
          return { value: t.id, label: t.name, color: "#000000" };
        });
        callback(clients);
      })
      .catch(er => {
        callback([]);
      });
  };

  renderErrorText = code => {
    switch (code) {
      case 170020:
      case 170021:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incorrectFile")
            }}
          />
        );
      case 170030:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incompatibleModel")
            }}
          />
        );

      default:
        return <span>{_("errorOccured")}</span>;
    }
  };

  renderClientEntityModal(selectedClient) {
    const { clientEntitySetting } = this.props;
    return (
      <TTPModal mask={true} visible={true} footer={null} width={600}>
        <div className="tamtam-modal upload-modal upload-modal__body">
          <ModalCloseButton onClose={this.handleCloseClientEntitySetting} />
          <div className="upload-modal__content">
            <DragModal>
              <div className="upload-modal__header small-12">
                <div className="upload-modal__header-icon">
                  <SettingIcon fill="#2495E1" size="20" />
                </div>
                <div
                  className="upload-modal__header-title"
                  style={{ display: "inline-block", marginRight: "auto" }}
                >
                  {_("Configuration d'entité")}
                </div>
              </div>
            </DragModal>
            <div className={styles.modal_content}>
              <h3>
                {_("Pour le client ")}{" "}
                <span
                  style={{
                    fontWeight: "700",
                    color: "rgba(0, 0, 0, 0.65)",
                    fontSize: ".9rem"
                  }}
                >
                  {selectedClient.name}
                </span>
              </h3>
              <div className={classnames("row")}>
                <div className="medium-12 small-12">
                  <div className={classnames("", styles.form_group)}>
                    <div className={styles.switch_frame}>
                      <span>{"C'est un client entité"} </span>
                      <Switch
                        id={selectedClient.id}
                        checked={selectedClient.isEntityClient}
                        onChange={() => this.handleCheckIsClientEntity()}
                      />
                    </div>

                    {!selectedClient.isEntityClient && (
                      <div style={{ marginBottom: "1rem" }}>
                        <AsyncSelect
                          value={
                            selectedClient.entityClient
                              ? {
                                  value: selectedClient.entityClient.id,
                                  label: selectedClient.entityClient.name,
                                  color: "#000"
                                }
                              : null
                          }
                          key={selectedClient.id + "collaborator"}
                          isMulti={false}
                          placeholder={_("Selectionner l'entité cliente liée")}
                          onChange={e => this.handleSelectClientEntity(e)}
                          classNamePrefix="ttp-select"
                          defaultOptions
                          loadOptions={this.loadClientSuggestions}
                          className={`ttp-select empty-box`}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.modal_footer}>
              <Button
                type={"success"}
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: 14,
                  height: 37,
                  margin: "18px 3px 0px",
                  background: `${
                    !selectedClient.disabledSave ? "#18A0FB" : "#f5f5f5"
                  }`,
                  float: "right",
                  textTransform: "uppercase",
                  color: `${
                    !selectedClient.disabledSave
                      ? "white"
                      : "rgba(0, 0, 0, 0.25)"
                  }`
                }}
                disabled={selectedClient.disabledSave}
                loading={clientEntitySetting.loading}
                onClick={this.handleSaveClientEntitySetting}
              >
                {_("save")}
              </Button>
              <Button
                type={"success"}
                style={{
                  fontFamily: "Roboto",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: 14,
                  height: 37,
                  margin: "18px 3px 0px",
                  background: "transparent",
                  float: "left",
                  textTransform: "uppercase",
                  color: "#6D7F92"
                }}
                onClick={this.handleCloseClientEntitySetting}
              >
                {_("cancel")}
              </Button>
            </div>
          </div>
        </div>
      </TTPModal>
    );
  }

  renderPaginate() {
    let { error, paginationPage, pageSize, nbResult } = this.props;
    if (error != null && error.code === 404) {
      return "";
    }
    return (
      <TTPPaginator
        onPageChange={this.handleOrganizationListPageChange}
        pageSize={pageSize}
        nbResult={nbResult}
        paginationPage={paginationPage}
      />
    );
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutsideYearsSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }
  handleChangeIsPrograssBar = () => {
    const { year } = this.props;
    if (year != 2020) {
      this.setState({ isProgressBar: true, nbrFetchingSideBar: 1 });
      this.setState({ countNbrClickedButton: 1 });
      this.handleUpdatedBudgetByRole();
      this.handleGetBudgetByRole();
    }
  };

  renderYearSelect = () => {
    const { yearDivIsVisible } = this.state;
    const { years, year } = this.props;
    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (this.state.yearDivIsVisible ? styles.customed_select_opened : "")
        }
      >
        <div className={styles.customed_select_header}>
          <span>{year}</span>
          <div className={styles.actions}>
            <div>
              <span
                className={styles.action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {years.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleSelectYear(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  handleSelectYear = year => {
    const { dispatch } = this.props;
    this.setState({ yearDivIsVisible: false });
    dispatch(setBudgetYear(year));
    dispatch(fetchClientsList());
  };

  handleOrganizationListPageChange = ({ selected }) => {
    this.props.dispatch(setClientsListPaginationPage(selected + 1));
  };

  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };

  handleOpenImportFinancialSheetModal = () => {
    const { dispatch } = this.props;
    dispatch(setImportClientsBudgetModal(true));
  };
  handleUpdatedBudgetByRole = () => {
    const { year } = this.props;
    this.props
      .dispatch(updatedBudgetByRole(year))
      .then(res => {
        this.setState({ updatedBudget: true });
      })
      .catch(er => {
        this.setState({ error: true });
      });
  };
  handleGetBudgetByRole = () => {
    const { year } = this.props;
    this.props.dispatch(getUpdatedBudget(year));
  };
  renderUpdateBudgetClientsCallout = error => {
    const { isProgressBar } = this.state;
    if (error != null && error.code === 170045) {
      return this.renderBudgetStillInProgress(error.title);
    } else {
      isProgressBar && this.props.dispatch(fetchClientsList());
    }
  };
  renderBudgetStillInProgress = message => {
    const { isProgressBar, nbrFetchingSideBar } = this.state;
    this.intervalID = setTimeout(() => {
      this.handleGetBudgetByRole();
    }, 7000);

    let nbrClientUpdated = message.match(/\d+/g)[0];
    let nbrClients = message.match(/\d+/g)[1];

    return (
      <div>
        {isProgressBar && (
          <div
            style={{
              paddingTop: 150,
              textAlign: "center",
              width: 400,
              margin: "auto"
            }}
          >
            <span
              style={{
                fontFamily: "Roboto",
                fontStyle: "normal",
                fontWeight: 450,
                fontSize: 18,
                color: "#3e3e3e"
              }}
            >
              {_("BudgetingInProgress")}{" "}
            </span>
            <br />
            {message}
            <Progress
              showInfo={false}
              percent={(nbrClientUpdated / nbrClients) * 100}
              size="small"
              status="active"
              strokeWidth={12}
              className={styles.progressBar}
            />
          </div>
        )}
        {nbrClientUpdated === nbrClients &&
          (nbrFetchingSideBar < 1 || nbrFetchingSideBar > 5) &&
          this.setState({ isProgressBar: false, nbrUpdated: 1 })}
        {nbrClientUpdated === nbrClients &&
          (nbrFetchingSideBar > 1 && nbrFetchingSideBar < 5) &&
          this.setState({ nbrFetchingSideBar: nbrFetchingSideBar + 1 })}
      </div>
    );
  };

  renderImportClientsBudget = () => {
    const { fetched } = this.props;

    if (fetched) {
      return (
        <div
          className="row medium-8"
          style={{
            marginTop: "2%",
            marginRight: "-30%"
          }}
        >
          <div className={"medium-3"}>
            <a
              target="_blank"
              className="btn secondary text-uppercase"
              onClick={
                !this.state.isProgressBar && this.handleChangeIsPrograssBar
              }
            >
              <SvgIcon icon={ICONS.BUDGET_PAGE_ICON} color="#18A0FB" />
              {_("Budgeting")}
            </a>
          </div>
          <div className={"medium-3"} style={{ marginLeft: "5px" }}>
            <a
              target="_blank"
              className="btn secondary text-uppercase"
              onClick={this.handleOpenImportFinancialSheetModal}
            >
              <SvgIcon icon={ICONS.UPLOAD} />

              {_("Import")}
            </a>
          </div>
        </div>
      );
    }

    return "";
  };

  render() {
    const {
      fetching,
      items,
      fetched,
      pageSize,
      nbResult,
      parameterSettings,
      erpData,
      errorUpdatedClient
    } = this.props;
    const {
      filterFormIsVisible,
      clientEntityModalIsVisible,
      selectedClient,
      isProgressBar
    } = this.state;

    return (
      <div>
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        <PageHeader
          header={_("clientList")}
          subHeader={_("subTitleClientList")}
          icon={ICONS.CLIENT_LIST_PAGE_ICON}
          customAddOn={this.renderImportClientsBudget()}
        />
        <div className="rmodal__center medium-11">
          <ClientListFilter
            filterFormIsVisible={this.handleFilterFormIsVisible}
            customAddOn={this.renderYearSelect()}
            pageSize={pageSize}
            nbResult={nbResult}
            fetching={fetching}
            button={true}
            getEntity={this.loadClientSuggestions}
          />
          {/***************  capacityPlanning viewer body *************/}
          <div className={styles.container}>
            {fetching ? (
              <div className={styles.ripple_loading}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" />
              </div>
            ) : isProgressBar ? (
              this.renderUpdateBudgetClientsCallout(errorUpdatedClient)
            ) : (
              <ClientsList
                items={items}
                handleOpenClientEntitySetting={
                  this.handleOpenClientEntitySetting
                }
                erpData={erpData}
                parameterSettings={parameterSettings}
              />
            )}
          </div>
        </div>
        <div
          className={`row align-center margin-bottom-2 ${filterFormIsVisible &&
            "add-margin-left"}`}
        >
          {!isProgressBar && (
            <div
              className={
                filterFormIsVisible ? "column medium-12" : "column medium-11"
              }
            >
              {fetched && items.length ? (
                this.renderPaginate()
              ) : (
                <div className="row pagination" />
              )}
              {clientEntityModalIsVisible &&
                selectedClient &&
                this.renderClientEntityModal(selectedClient)}
            </div>
          )}
        </div>
        <ImportClientsBudgetModal />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.clients.list.fetching,
  fetched: state.clients.list.fetched,
  error: state.clients.list.error,
  year: state.clients.list.year,
  years: state.clients.list.years,
  items: state.clients.list.items,
  nbResult: state.clients.list.nbResult,
  pageSize: state.clients.list.pageSize,
  filter: state.clients.list.filter,
  paginationPage: state.clients.list.paginationPage,
  clientEntitySetting: state.clients.entitySetting,
  parameterSettings: state.parameterSettings.data,
  erpData: state.erpData.data.items,
  errorUpdatedClient: state.budget.tree.error
});

export default connect(mapStateToProps)(ClientVue);



// WEBPACK FOOTER //
// ./src/components/ClientsList/ClientVue.js